import styled from 'styled-components';

const NewJobWrapper = styled.div`
  .screen-caption {
    display: flex;
    align-items: center;
    height: 60px;
    text-align: center;
    position: relative;
    &:before, &:after {
      position: absolute;
      height: 3px;
      content: '';
      width: 100%;
      background-color: ${p => p.theme.color.border};
      bottom: 0;
      left: 0;
    }
    &:after {
      width: ${p => p.percent}%;
      background-color: ${p => p.theme.color.borderActive};
    }
    p {
      margin: 0;
      font-size: 1.5em;
    }
  }
  .cancel-new-job {
    position: absolute;
    left: 1em;
    display: flex;
    align-items: center;
    p {
      margin-left: .8em;
    }
  }
  .screen-title {
    width: 100%
  }

  .content {
    height: calc(100vh - 62px - 60px - 80px);
    overflow: auto;
  }

  .footer {
    box-sizing: border-box;
    text-align: center;
    height: 80px;
    border-top: 1px solid ${p => p.theme.color.border};
  }

  .btns-wrapper {
    max-width: 500px;
    width: 100%;
    position: relative;
    height: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    .btn-primary {
      width: 250px;
    }
    .btn-like-link {
      position: absolute;
      left: 0;
    }
  }

  .section {
    border-bottom: 1px solid ${p => p.theme.color.border};
    padding-bottom: 1em;
    &:last-of-type {
      border: none;
    }
  }

  .section-title {
    padding: 1em 0;
    margin: 0;
    font-weight: normal;
    font-size: 1.1em;
  }

  .radio-items-wrapper {
    display: flex;
    flex-wrap: wrap;
  }

`;

export default {
  NewJobWrapper
};